<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <span>{{ t("account360-dashboard-settings.select_dashboard_account") }}</span>
      <app-account-group-selector
        [selectedAccountGroupId]="selectedAccountGroup()?.id"
        (accountGroupChange)="selectAccountGroup($event)"
        [accountType]="data.dashboardAccountType"
        [organizationId]="selectedOrganizationId()"
      />
    </div>
    @if (selectedAccountGroup()) {
      <div class="flex flex-col gap-2">
        <span>{{ t("account360-dashboard-settings.select_dashboard_marketplace") }}</span>
        <app-marketplace-selector
          [marketplaces]="accountGroupMarketplaces()"
          [selectedMarketplace]="selectedMarketplace()"
          (marketplaceChange)="selectMarketplace($event)"
        />
      </div>
    }
  </div>
  <div class="mt-8 flex justify-between">
    <button iButton variant="ghost" size="md" class="mr-2" (click)="close()">{{ t("common.cancel") }}</button>
    <button iButton size="md" (click)="updateDashboardAccount()">
      {{ t("account360-dashboard-settings.update_dashboard_account") }}
    </button>
  </div>
</ng-container>
